<template>
  <div>
    <Row>
      <Col :xs="24" :sm="24" :md="18" :lg="14">
        <Form
          ref="form"
          :model="forms"
          :label-width="150"
          :disabled="action == 'view' ? true : false"
          @submit.native.prevent
        >
          <form-body
            :forms="forms"
            :items="items"
            :disabled="action == 'view' ? true : false"
          ></form-body>

          <button-box v-if="action != 'view'">
            <Poptip confirm title="请检查数据, 再确认提交" @on-ok="handleSubmit">
              <button-sub :loading="sloading">保存</button-sub>
            </Poptip>
            <button v-if="this.knowedgeQeck" @click="handleSubmitKnow" class="knowledge">
              保存并转存知识库
            </button>
            <button-back></button-back>
          </button-box>
        </Form>
      </Col>
    </Row>
    <Modal title="图片预览" v-model="imgVisible">
      <img :src="imgUrl" style="width: 100%" />
    </Modal>
    <!-- 动态组件 -->
    <component
      v-for="(item, index) in extRender || []"
      :key="index"
      :ref="item"
      :is="item"
    ></component>
  </div>
</template>
<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
import Change from "./question.vue";
export default {
  extends: baseEdit,
  components: {
    change: Change,
  },
  data() {
    return {
      mname: "work",
      key: "id",
      knowedgeQeck: true,
      ll: [],
      url: {
        get: "/admin/system/work",
      },
      items: [
        {
          label: "科室",
          name: "deskId",
          value: "",
          type: "selectDesk",
          width: "400px",
          dropList: [],
          rules: [
            {
              required: true,
              message: "科室不能为空",
              trigger: "blur",
              type: "number",
            },
          ],
          selected: 0,
          onChange: this.onChangefacility,
        },
        {
          label: "科室信息",
          name: "deskinfo",
          value: "",
          type: "input",
          width: "400px",
          disabled: "true",
        },
        {
          label: "资产",
          name: "facilityNo",
          value: "",
          type: "select",
          dropList: [],
          width: "480px",
          rules: [{ required: true, trigger: "blur" }],
          onChange: this.onChangeFacilityType,
        },
        {
          label: "故障类型",
          name: "typeParentId",
          name2: "typeId",
          key: "name",
          value: "",
          value2: "",
          type: "selectTypeChild",
          width: "200px",
          dropList: [],
          dropList2: [],

          // desc: "如确认非硬件问题请选择关联性报修！",
          rules: [
            {
              required: true,
              message: "故障类型不能为空",
              trigger: "blur",
              type: "number",
            },
          ],
        },
        {
          label: "问题描述",
          name: "descr",
          value: "",
          dropList: [],
          type: "pullinput",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
          onFocus: this.onTextFocus,
          onChange: this.onTextChange,
          onExtClick: this.onTextExtClick,
        },
        {
          label: "处理内容",
          name: "maintainerContent",
          value: "",
          dropList: [],
          type: "pullinput",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
          onFocus: this.onTextFocus,
          onChange: this.onTextChange,
          onExtClick: this.onTextExtClick,
        },
        {
          label: "故障原因",
          name: "teackRemark",
          value: "",
          dropList: [],
          type: "pullinputRemark",
          width: "300px",
          onFocus: this.onTextFocus,
          onChange: this.onTextChange,
          onExtClick: this.onTextExtClick,
        },
        {
          label: "处理状态",
          name: "state",
          value: 3,
          type: "select",
          width: "240px",
          dropList: [{ value: 3, name: "已完成" }],
          disabled: "true",
        },
      ],
      forms: {
        repairSource: 1,
        maintainerContent: "",
        teackRemark: "",
        typeParentId: 0,
        deskinfo: null,
        msgkv: "",
      },
    };
  },
  computed: {
    extRender() {
      return ["change"];
    },
  },
  created() {
    this.loadLevelData();
    this.loadworkData();
    this.loadcommonData();
    let query = this.$route.query;

    if (query.kv) {
      this.kv = query.kv;
    }
    if (query.msgkv) {
      this.msgkv = query.msgkv;
    }
  },
  mounted() {},
  methods: {
    loadDeskData(repairPhone) {
      // 通过pk查询字典数据
      let q = {};
      q.phone = repairPhone;
      $utils.api.load(`/admin/system/desk/selectList`, q).then((res) => {
        if (res && res.rows.length > 0) {
          let ll = res.rows;
          this.forms.deskId = ll[0].id;
          this.onChangefacility(this.forms.deskId);
        }
      });
    },
    handleSubmitKnow() {
      let q = this.forms;
      q.isKnow = 1;
      if (q.typeId === undefined || q.typeId === "" || q.typeId === null) {
        q.typeId = q.typeParentId;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(
              `/admin/system/work/callCenterAdd`,
              q,
              this.action == "edit" ? "PUT" : "POST"
            )
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      q.isKnow = 0;
      if (q.typeId === undefined || q.typeId === "" || q.typeId === null) {
        q.typeId = q.typeParentId;
      }
      if (this.kv === "flash" || this.cv === "flash") {
        this.forms.isFastOrder = 1;
      } else {
        this.forms.isFastOrder = 0;
      }
      this.$refs.form.validate((valid) => {
        if (valid && this.msgkv == "callCenter") {
          this.sloading = true;
          q.callId = this.kv;
          $utils.api
            .load(
              `/admin/system/work/callCenterAdd`,
              q,
              this.action == "edit" ? "PUT" : "POST"
            )
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
        if (valid && this.msgkv == "add") {
          this.forms.callId = null;
          this.sloading = true;
          $utils.api
            .load(`/admin/system/work`, q, this.action == "edit" ? "PUT" : "POST")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
        if (valid && this.msgkv == "flashadd") {
          this.forms.callId = null;
          this.sloading = true;
          $utils.api
            .load(
              `/admin/system/work/flashAdd`,
              q,
              this.action == "edit" ? "PUT" : "POST"
            )
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
    onChangefacility(deskId) {
      this.loadfacilityData(deskId);
    },
    onChangeFacilityType(facilityNo) {
      this.loadfacilitytypeData(facilityNo);
    },
    onTextChange(val) {},
    onTextFocus() {},
    onTextExtClick(v) {
      let _this = this;
      if (v.name === "descr") {
        this.$refs.change[0].loadData(1);
        // 按钮显示常用语
        if (this.$refs.change && this.$refs.change[0]) {
          this.$refs.change[0].open();
          this.$refs.change[0].getText = (val) => {
            _this.forms.descr += val + "";
          };
        }
      } else if (v.name === "maintainerContent") {
        this.$refs.change[0].loadData(2);
        // 按钮显示常用语
        if (this.$refs.change && this.$refs.change[0]) {
          this.$refs.change[0].open();
          this.$refs.change[0].getText2 = (val) => {
            _this.forms.maintainerContent += val + "";
          };
        }
      } else if (v.name === "teackRemark") {
        this.$refs.change[0].loadData(3);
        // 按钮显示常用语
        if (this.$refs.change && this.$refs.change[0]) {
          this.$refs.change[0].open();
          this.$refs.change[0].getText3 = (val) => {
            _this.forms.teackRemark += val + "";
          };
        }
      }
    },
    handleSearch(descr) {
      let ll = this.ll;
      let newll = [];
      for (let index = 0; index < ll.length; index++) {
        let obj = ll[index] || {};
        let descrOld = obj.descr;
        if (descrOld.indexOf(descr) != -1) {
          newll.push(obj);
        }
      }
      let dropListarr = [];
      for (let index = 0; index < newll.length; index++) {
        const element = newll[index];
        let xx = {};
        xx.value = element.descr;
        xx.name = element.descr;
        xx.children = element.children || [];
        dropListarr.push(xx);
      }
      for (let index = 0; index < this.items.length; index++) {
        const element = this.items[index];
        if (element && element.name == "descr") {
          this.items[index]["dropList"] = dropListarr;
          // this.items[index]["dropList"] = (
          //   this.items[index]["dropList"] || []
          // ).concat(dropList);
        }
      }
      // return a;
    },
    loadcommonData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/common/list", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          this.ll = ll;
        }
      });
    },
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load(`/admin/system/desk/selectList`, q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.deskName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "deskId") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    loadfacilityData(deskId) {
      let that = this;
      if (deskId) {
        // 通过pk查询字典数据
        $utils.api.load(`/admin/system/desk/${deskId}`).then((res) => {
          if (res && res.data) {
            let workInfotemp = "";
            if (res.data.principal !== null && res.data.principal !== undefined) {
              workInfotemp = res.data.principal;
            }
            // console.log(666,workInfotemp)
            if (res.data.phone !== null && res.data.phone !== undefined) {
              workInfotemp = workInfotemp + "/" + res.data.phone;
            }
            // console.log(777,workInfotemp)
            if (res.data.address !== null && res.data.address !== "") {
              workInfotemp = workInfotemp + "/" + res.data.address;
            }
            // console.log(888,workInfotemp)
            that.forms.deskinfo = workInfotemp;
          }
        });
      } else {
        that.forms.deskinfo = "";
      }

      // 通过pk查询字典数据
      let q = {};
      q.state = 2;
      q.deskId = deskId;
      $utils.api.load("/admin/system/facility/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.facilityNum;
            xx.name =
              element.facilityNum +
              "_" +
              element.facilityName +
              "_" +
              element.installationSite;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "facilityNo") {
              this.items[index]["dropList"] = dropList;
            }
          }
        }
      });
    },
    loadfacilitytypeData(facilityNo) {
      if (facilityNo) {
        let q = {};
        q.facilityNum = facilityNo;
        $utils.api.load("/admin/system/facility/workType", q).then((res) => {
          if (res && res.rows) {
            let ll = res.rows;
            let dropList = [];
            for (let index = 0; index < ll.length; index++) {
              const element = ll[index];
              let xx = {};
              xx.value = element.id;
              xx.name = element.name;
              xx.children = element.children || [];
              dropList.push(xx);
            }
            for (let index = 0; index < this.items.length; index++) {
              const element = this.items[index];
              if (element && element.name == "typeParentId") {
                this.items[index]["dropList"] = dropList;
              }
            }
            this.forms.typeParentId = ll[0].id;
          }
        });
      } else {
        let q = {};
        q.facilityNum = facilityNo;
        $utils.api.load("/admin/system/facility/workType", q).then((res) => {
          if (res && res.rows) {
            let ll = res.rows;
            let dropList = [];
            for (let index = 0; index < ll.length; index++) {
              const element = ll[index];
              let xx = {};
              xx.value = element.id;
              xx.name = element.name;
              xx.children = element.children || [];
              dropList.push(xx);
            }
            for (let index = 0; index < this.items.length; index++) {
              const element = this.items[index];
              if (element && element.name == "typeId") {
                this.items[index]["dropList"] = dropList;
              }
            }
          }
        });
      }
    },
    //选择故障类型下拉框
    async loadworkData() {
      // 通过pk查询字典数据
      let q = {};
      let res = await $utils.api.load("/admin/system/workType/list", q);
      if (res && res.rows) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.name;
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "typeParentId") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
    //选择故障类型下拉框
    async loadChildData(typeParentId) {
      // 通过pk查询字典数据
      let parentId = typeParentId;
      let res = await $utils.api.load(`/admin/system/workType/parentId/${parentId}`);
      if (res && res.data) {
        let ll = res.data;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value2 = element.id;
          xx.name2 = element.name;
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name2 == "typeId") {
            this.items[index]["dropList2"] = dropList;
          }
        }
      }
    },
  },
};
</script>

<style lang="less">
.workcolor {
  margin: 5px 5px 5px 150px;
  width: 80px;
  height: 30px;
}

.knowledge {
  margin: 5px 5px 5px 150px;
  width: 125px;
  height: 30px;
  background-color: #1890ff;
  color: #f6f8f7;
  border: none;
}

.completecolor {
  width: 80px;
  height: 30px;
  margin: 5px 5px 5px 30px;
}
</style>
